import app from '../app.first';
import { each, escape } from 'lodash';

app.CompaniesCrud = class extends app.Component {
    onReady () {
        $('#parent-id').select2({
            width: '100%',
            minimumResultsForSearch: -1,
            minimumInputLength: 3,
            ajax: {
                url: '/ajax/search-companies',
                dataType: 'json',
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
            }
        });
	}
}
